<template>
  <div class="app-container">
    <el-form :model="queryParams" ref="queryForm" v-show="showSearch" :inline="true" class="bg-white p-1">
      <el-form-item label="日志名称" prop="query.logName">
        <el-input
            v-model="queryParams.query.logName"
            placeholder="请输入日志名称"
            clearable
            size="small"
            style="width: 240px"
            @keyup.enter.native="handleQuery"
        />
      </el-form-item>
      <el-form-item label="来源" prop="query.sourceCode">
        <el-select v-model="queryParams.query.sourceCode" placeholder="请选择来源" clearable size="small" style="width: 240px" @keyup.enter.native="handleQuery">
          <el-option label="运营" value="1"></el-option>
          <el-option label="小程序" value="2"></el-option>
        </el-select>
      </el-form-item>
      <!-- <el-form-item label="权限字符" prop="logKey">
        <el-input
            v-model="queryParams.query.logKey"
            placeholder="请输入权限字符"
            clearable
            size="small"
            style="width: 240px"
            @keyup.enter.native="handleQuery"
        /> 
      </el-form-item>-->
      <el-form-item>
        <el-button type="primary" icon="el-icon-search" size="mini" @click="handleQuery">搜索</el-button>
        <el-button icon="el-icon-refresh" size="mini" @click="resetQuery">重置</el-button>
      </el-form-item>
    </el-form>
    <el-table v-loading="loading" :data="logList" @selection-change="handleSelectionChange" :header-cell-style="{background: '#DDD'}">
      <el-table-column align="center" type="index" label="序号" width="80"/>
      <el-table-column label="类型"  align="center"   prop="sourceName" width="80">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.type==='0'" type="success">正常</el-tag>
          <el-tag v-else-if="scope.row.type==='9'" type="danger">错误</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="日志标题" align="center" prop="title" :show-overflow-tooltip="true" width="200"/>
      <el-table-column label="来源"    align="center" prop="sourceName" width="100">
        <!-- <template slot-scope="scope">
          <el-tag v-if="scope.row.sourceCode==='1'">操作系统</el-tag>
          <el-tag v-else-if="scope.row.sourceCode==='2'" type="success">小程序</el-tag>
        </template> -->
      </el-table-column>
      <el-table-column label="时间" align="center" prop="createTime" width="160">
        <template slot-scope="scope">
          <span>{{ parseTime(scope.row.createTime) }}</span>
        </template>
      </el-table-column>
      <el-table-column label="用户"  align="center" prop="userName" width="100"/>
      <el-table-column label="IP地址"  align="center" prop="remoteAddr" width="150"/>
      <el-table-column label="类名"  align="center" prop="className" width="400"/>
      <el-table-column label="方法名"  align="center" prop="methodName" width="100"/>
      <el-table-column label="请求URI"  align="center" prop="requestUri" width="200"/>
      <el-table-column label="请求方式"  align="center" prop="requestMethod" width="80"/>
      <el-table-column label="参数"  align="center" prop="requestParam" :show-overflow-tooltip="true" width="300"/>
      <el-table-column label="响应"  align="center" prop="responseResult" :show-overflow-tooltip="true" width="300"/>
      <el-table-column label="状态码"  align="center" prop="responseStateCode" width="80">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.responseStateCode==='200'" type="success">200</el-tag>
          <el-tag v-else-if="scope.row.responseStateCode==='500'" type="danger">500</el-tag>
          <el-tag v-else-if="scope.row.responseStateCode==='401'" type="waring">401</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="时长"  align="center" prop="responseTime" width="80"/>


      <el-table-column label="操作" align="center" class-name="small-padding fixed-width" fixed="right">
        <template slot-scope="scope">
          <el-button
              size="mini"
              type="text"
              icon="el-icon-eye"
              @click="look(scope.row)"
          >详情
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <pagination
        v-show="total>0"
        :total="total"
        :page.sync="queryParams.pageNum"
        :limit.sync="queryParams.pageSize"
        @pagination="getList"
    />
    <el-drawer
        title="详情"
        :visible.sync="open"
        :with-header="false">
      <el-descriptions title="日志" border :column="1">
        <el-descriptions-item label="日志类型">
          <el-tag v-if="form.type==='0'" type="success">正常</el-tag>
          <el-tag v-else-if="form.type==='9'" type="danger">错误</el-tag>
        </el-descriptions-item>
        <el-descriptions-item label="日志标题">{{form.title}}</el-descriptions-item>
        <el-descriptions-item label="来源">
          <el-tag v-if="form.sourceCode==='1'" type="">{{form.sourceName}}</el-tag>
          <el-tag v-else-if="form.sourceCode==='2'" type="danger">{{form.sourceName}}</el-tag>
        </el-descriptions-item>
        <el-descriptions-item label="操作IP">{{form.remoteAddr}}</el-descriptions-item>
        <el-descriptions-item label="类名">{{form.className}}</el-descriptions-item>
        <el-descriptions-item label="方法名">{{form.methodName}}</el-descriptions-item>
        <el-descriptions-item label="请求URI">{{form.requestUri}}</el-descriptions-item>
        <el-descriptions-item label="操作方式">{{form.requestMethod}}</el-descriptions-item>
        <el-descriptions-item label="状态码">
          <el-tag v-if="form.responseStateCode==='200'" type="success">200</el-tag>
          <el-tag v-else-if="form.responseStateCode==='500'" type="waring">500</el-tag>
          <el-tag v-else-if="form.responseStateCode==='401'" type="danger">401</el-tag>
        </el-descriptions-item>
        <el-descriptions-item label="执行时长">{{form.responseTime}} 毫秒</el-descriptions-item>
        <el-descriptions-item label="用户">{{form.userName}}</el-descriptions-item>
        <el-descriptions-item label="参数">
          <json-viewer :value="form.requestParamJson" copyable theme="my-awesome-json-theme"></json-viewer>
        </el-descriptions-item>
        <el-descriptions-item label="响应">
          <json-viewer :value="form.responseResultJson" copyable theme="my-awesome-json-theme"></json-viewer>
        </el-descriptions-item>
      </el-descriptions>
    </el-drawer>
  </div>
</template>

<script>
import {logPage} from "@/api/sys/log";
import '@/styles/awesome-json-theme.scss';
import JsonViewer from 'vue-json-viewer'
export default {
  name: "Log",
  components:{
    JsonViewer
  },
  data() {
    return {
      // 遮罩层
      loading: true,
      // 显示搜索条件
      showSearch: true,
      // 总条数
      total: 0,
      // 日志表格数据
      logList: [],
      // 是否显示弹出层
      open: false,
      // 日期范围
      dateRange: [],
      // 查询参数
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        query: {
          logName: undefined,
          logKey: undefined,
          sourceCode: undefined,
          status: undefined
        }
      },
      // 表单参数
      form: {},
    };
  },
  created() {
    this.getList();
  },
  methods: {
    look(data){
      this.form =  Object.assign({},data);
      if(this.form.requestParam){
        this.form.requestParamJson = JSON.parse(this.form.requestParam);
      }else {
        this.form.requestParamJson = '无';
      }
      if(this.form.responseResult){
        this.form.responseResultJson = JSON.parse(this.form.responseResult);
      }else {
        this.form.responseResultJson = '无';
      }
      this.open=true
    },
    /** 查询日志列表 */
    getList() {
      this.loading = true;
      logPage(this.addDateRange(this.queryParams, this.dateRange)).then(
          response => {
            this.logList = response.data.rows;
            this.total = response.data.total;
            this.loading = false;
          }
      );
    },
    /** 搜索按钮操作 */
    handleQuery() {
      this.queryParams.pageNum = 1;
      this.getList();
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.dateRange = [];
      this.queryParams.query.logName = undefined;
      this.queryParams.query.sourceCode = undefined;
      this.queryParams.query.logKey = undefined;
      this.queryParams.query.status = undefined;
      this.resetForm("queryForm");
      this.handleQuery();
    },
  }
};
</script>
